/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {RouteFilter} from '@ion/dls/src/filters/RouteFilter';
import {Filters} from '@ion/dls/src/types/types';
import {FilterParamsType} from '../types';

interface RoutesFilterParamsType extends FilterParamsType {}

export const RoutesFilter = ({
  isPhone,
  globalGroupId,
  toggleView,
  filterState,
  handleSubmit
}: RoutesFilterParamsType) => (
  <RouteFilter isMobileView={isPhone}
    name={Filters.routes}
    accountId={globalGroupId}
    onCancel={toggleView}
    onMenuClose={toggleView}
    filterState={filterState[Filters.routes]}
    onSubmit={handleSubmit} />
);

export default RoutesFilter;
